import p from './paragraphs';

const _default = {
  color: 'text',
  fontFamily: 'body',
  fontSize: 2,
  fontWeight: 1,
  mb: 2,
  '>span': { color: 'error' },
};

const error = {
  ..._default,
  color: 'error',
  '>span': { color: 'error' },
};

const heading = {
  ..._default,
  fontSize: 3,
  pb: 0,
  mb: 0,
};

const headingSmall = {
  ..._default,
  fontSize: 2,
  pb: 0,
  mb: 0,
};

const sideLabel = {
  fontSize: 3,
  fontWeight: 0,
  ml: 2,
  '>label': {
    fontSize: 3,
    fontWeight: 0,
    mb: 0,
  },
};

const radioGroupItemLabel = {
  fontSize: 3,
  fontWeight: 0,
  display: 'flex',
  alignItems: 'center',
};

const borderBottomSolid = {
  pb: [null, null, '3px'],
  borderBottom: [null, null, '1px solid'],
  borderBottomColor: [null, null, 'lightMain1'],
};

const sustainability = {
  ...p.captionRegularSmall,
  ...borderBottomSolid,
};

const reviews = {
  ...p.captionRegularSmall,
  ...borderBottomSolid,
  fontWeight: 0,
  width: 'fit-content',
};

const labels = {
  _default,
  error,
  sideLabel,
  radioGroupItemLabel,
  sustainability,
  reviews,
  heading,
  headingSmall,
};

export default labels;
